export default () =>
  import(/* webpackChunkName: 'coffee/app/download/employee' */ './Employee');
